import { redirect } from '@tanstack/react-router';

// Legacy URL for changing your own password (`/account/team/:id/passwords/edit` lands here too).
// Replace, so Back doesn't return here only to be sent forward again.
export function redirectToPasswordEditor(): never {
  throw redirect({ to: '/settings/personal', search: { isEditingPassword: true }, replace: true });
}
